<p-table [value]="invalidEntriesWrappers" styleClass="dynamic-size-table">
  <ng-template pTemplate="header">
    <tr>
      <th>#</th>
      <th>Details</th>
      <th *ngFor="let col of columns">{{ col.header }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr>
      <td>{{ item.lineNumber }}</td>
      <td>
        <button
          type="button"
          pButton
          (click)="showDetails(item.entry)"
          icon="fa ui-icon-info"
          label="Details"
        ></button>
      </td>
      <td *ngFor="let col of columns">
        {{ col.field }}
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- DATATABLE DEPRECATED ---
<p-dataTabl [value]="invalidEntriesWrappers" [immutable]="false" styleClass="dynamic-size-table">
    <p-column field="lineNumber" header="#"></p-column>
    <p-column>
        <ng-template let-wrapper="rowData" pTemplate="body">
            <button type="button" pButton (click)="showDetails(wrapper.entry)" icon="fa ui-icon-info" label="Details"></button>
        </ng-template>
    </p-column>
    <p-column *ngFor="let col of columns" [header]="col.header" [field]="col.field"></p-column>
</p-dataTable>
-->

<p-dialog
  [(visible)]="dialogIsVisible"
  [modal]="true"
  [style]="{ width: '80%' }"
  [contentStyle]="{ overflow: 'visible' }"
  (onHide)="onDetailsHide()"
>
  <p-header>
    <span>Details</span>
  </p-header>

  <div class="ui-g" style="margin-bottom: 25px">
    <div *ngIf="entry">{{ entry.errorMessage }}</div>

    <p-table
      [value]="cellsForDetails"
      *ngIf="cellsForDetails && cellsForDetails.length != 0"
      styleClass="dynamic-size-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Order Number</th>
          <th>Field</th>
          <th>Value</th>
          <th>Message</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.orderNumber }}</td>
          <td>{{ item.targetFieldName }}</td>
          <td>{{ item.value }}</td>
          <td>
            <span style="color: red" class="error-message" title="{{ item.errorMessage }}">{{
              item.errorMessage
            }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLE DEPRECATED ---

    <p-dataTabl [value]="cellsForDetails" *ngIf="cellsForDetails && cellsForDetails.length != 0"
                 styleClass="dynamic-size-table">
      <p-column header="Order number" field="orderNumber"></p-column>
      <p-column header="Field" field="targetFieldName"></p-column>
      <p-column header="Value" field="value"></p-column>
      <p-column header="Message" field="errorMessage">
        <ng-template let-cell="rowData" pTemplate="body">
          <span style="color:red;" class="error-message" title="{{cell.errorMessage}}">{{cell.errorMessage}}</span>
        </ng-template>
      </p-column>
    </p-dataTable>

    -->
  </div>
</p-dialog>
